package fr.anthony.abkweb.data

val techBadgeList = listOf(
    "kotlin", "Kotlin Multiplatform (KMP)", "Jetpack Compose & SwiftUI", "Compose HTML", "Ktor",
    "Coroutines & Flow", "Room / SQLDelight", "Koin", "Clean Architecture"
)